/******************************************************************************
*  If changes are made to this file, be sure to increment the WebsiteVersion  *
*  in the AppSettings so the client side cache is invalidated.                *
*******************************************************************************/

/*global jQuery, console*/

(function ($, window) {

    "use strict";

    $(document).foundation({
        offcanvas: {
            close_on_click: true
        }
    });

    window.swg = window.swg || {};

    //------ Global Variables-------
    var windowMobile = $(window).width() >= 1 && $(window).width() <= 767,
        windowTablet = $(window).width() >= 768 && $(window).width() <= 1024,
        windowDesktop = $(window).width() > 1024,
        productPage;
    var fnOldSearchOnClick = null;
    var dataLayer = [];


    function getParameterByName(name) {
        name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
        var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
            results = regex.exec(location.search);
        return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
    }

    if (windowMobile) {
        if ($(".video-hero").length) {

            $(' body').addClass('video-page');

        }
    }

    swg.productDetail = {

        init: function () {
            this.validateQuantity();
            this.initBreadcrumb();
            this.initCustPartNoTable();
        },

        initBreadcrumb: function () {
            var text = getParameterByName("part");
            if (text != "") {
                var prevText = document.title.substring(document.title.indexOf('|'));
                document.title = text + ' ' + prevText;
                $("h1").text(text);
                var last = '<span class="current" data-href="' + window.location.pathname + '">' + text + '</span>';
                $('.breadcrumbs').append(last);
            }
        },

        validateQuantity: function () {

            var quantityInput = $('#content_0_txtQuantity');

            $('#content_0_btnBuy').on('click', function (e) {
                if (swg.validation.validateText(quantityInput, true)) {
                    return true;
                } else {
                    e.preventDefault();
                    $('#content_0_btnBuy').css('border', '0');
                    return false;
                }
            });
        },

        initCustPartNoTable: function () {
            var $form = $("#addCustomPartNumberPopup");

            $("#btnShowPartNumDetails").on('click', function (e) {
                $("#customerPartNoDetails").show();
                $("#btnHidePartNumDetails").show();
                $("#btnShowPartNumDetails").hide();
            });

            $("#btnHidePartNumDetails").on('click', function (e) {
                $("#customerPartNoDetails").hide();
                $("#btnHidePartNumDetails").hide();
                $("#btnShowPartNumDetails").show();
            });

            $('.customer-part-number-add').on('click', function (e) {
                $form.find('#txtUserPartNum').val('');
                $form.find("#txtExistingUserPartNum").val();
                $form.foundation('reveal', 'open');
                $form.find('div.error').removeClass("error");
            });

            $('.customer-part-number-edit').on('click', function () {

                var existingVal = $(this).data("partnumber");
                $form.find('#txtUserPartNum').val('');
                $form.find("#txtExistingUserPartNum").val(existingVal);
                $form.foundation('reveal', 'open');
                $form.find('div.error').removeClass("error");
            });

            $form.find('#btnSaveMyPartNumber').on("click", function (e) {
                e.preventDefault();

                var isValidForm = true;

                $($form.find('.required').get().reverse()).each(function () {

                    var $element = $(this);

                    //Regular Input Text
                    isValidForm = swg.validation.validateText($element, false) && isValidForm;
                    isValidForm = swg.validation.validateHTML($element, false) && isValidForm;
                });

                if (isValidForm) {

                    var url = '/servicesWS/Forms.asmx/AddUpdatePartNumbers';

                    var swagelokPartNumber = $form.find("#txtSwagelokPartNum").val();
                    var userPartNumber = $form.find("#txtUserPartNum").val();
                    var existingUserPartNumber = $form.find("#txtExistingUserPartNum").val();
                    var dataObject = { 'swagelokPartNumber': swagelokPartNumber, 'userPartNumber': userPartNumber, 'existingUserPartNumber': existingUserPartNumber };

                    $('.ajaxProgress').show();

                    $.ajax({
                        url: url,
                        type: 'POST',
                        contentType: 'application/json',
                        dataType: 'json',
                        data: JSON.stringify(dataObject),
                        success: function (data) {
                            window.location.reload();
                        }

                    });

                    return false;
                }
                else {

                    return false;
                }

            });

            $('.customer-part-number-delete').on("click", function (e) {
                e.preventDefault();

                var url = '/servicesWS/Forms.asmx/DeletePartNumbers';
                var userPartNumber = $(this).data("partnumber");
                var dataObject = { 'userPartNumber': userPartNumber, };

                $.ajax({
                    url: url,
                    type: 'POST',
                    contentType: 'application/json',
                    dataType: 'json',
                    data: JSON.stringify(dataObject),
                    success: function (data) {
                        window.location.reload();
                    }
                });

                return false;
            });
        },
    };

    swg.navigation = {

        init: function () {
            this.mobileSearch();
            this.topLinkMenus();
            this.highlightNavItem();
            this.stickyNav();
        },

        mobileSearch: function () {
            $('#mobile-search-icon').closest('a').on('click', function (e) {
                e.preventDefault();
                if ($('.mobile-search-wrapper ').hasClass('open')) {
                    $('.mobile-search-wrapper ').hide().removeClass('open');
                } else {
                    $('.mobile-search-wrapper ').show().addClass('open');
                }
            });

            $('.input-clear').on('click', function () {

                $('.global-search').val('');

            });
        },

        topLinkMenus: function () {

            $("#logout_link").on("click", function (e) {

                e.preventDefault();
                var url = '/servicesWS/Forms.asmx/Logout';

                $.ajax({
                    url: url,
                    type: 'POST',
                    contentType: 'application/json',
                    dataType: 'json',
                    success: function (data) {
                        location.href = data.d;
                    }
                });

            });

            $('.header-top-links > li > a').on('click', function (e) {
                var noLangPopup = $("#NoLangPopup").val() === "true";

                if ($(this).find('span').hasClass('search')) {
                    e.preventDefault();
                    return;
                }
                $("<span class='arrow-autocomplete'></span>").insertBefore(".ui-autocomplete");

                if ($("#hdnIsMinisite").val() === "Y" && !noLangPopup && this.href.indexOf("products.") >= 0) {
                    $('#corporatePopup').foundation('reveal', 'open');
                    $('#aContinueToCorp').prop("href", this.href);
                } else {
                    window.location.href = this.href;
                }

                if ($(this).attr('id').indexOf('aLocateServices') === -1 && $(this).attr('id').indexOf('aCart') === -1) {
                    var dataVal = $(this).attr('id'),
                        accountLi = $(this).parent('li').width(),
                        accountLiPos = ($(this).offset().left) - ($('.submenu').offset().left),
                        submenuWidth = $('.submenu-top-links').width() / 2,
                        accountLiWidth = accountLi / 2;

                    e.preventDefault();

                    $('.header-top-links  > li > a').each(function () {
                        var activeClass = $(this).attr('id') + '-on';
                        $(this).children().first().removeClass(activeClass);
                    });

                    var $currentMenu,
                        $currentTip,
                        arrowPos;

                    if (dataVal !== 'language') {

                        $currentMenu = $(".submenu-top-links[data-menu='" + dataVal + "']");
                        $currentTip = $(".menu-tip[data-menu='" + dataVal + "']");
                        arrowPos = accountLiPos + accountLiWidth - 5;

                        $('.submenu-top-links').not($currentMenu).hide();
                        $('.menu-tip').not($currentTip).hide();

                        if (windowMobile) {


                            arrowPos = $(this).offset().left + ($(this).width() / 2) - 10;
                            $currentMenu.stop().slideToggle();
                            $currentTip.stop().slideToggle().css('left', arrowPos);
                            $(this).children('.' + dataVal).toggleClass(dataVal + '-on');

                        } else {
                            $currentMenu.stop().slideToggle();
                            $currentTip.stop().slideToggle().css('left', (arrowPos - 5));
                            $(this).children('.' + dataVal).toggleClass(dataVal + '-on');
                            $(this).children('.icon-label').toggleClass(dataVal + '-label-on');

                            if (windowTablet) {
                                $currentMenu.css('left', (accountLiPos + (accountLiWidth - submenuWidth)));
                            } else {
                                $currentMenu.css('left', (accountLiPos + (accountLiWidth - submenuWidth)));
                            }

                        }
                    } // end language
                    else {
                        $('.submenu-top-links').hide();
                        $('.menu-tip').hide();
                        $('#languagePopup').foundation('reveal', 'open');
                    }
                }

            });


            if (windowTablet) {

                var navItemsR = $('nav > ul > li').has('ul'),
                    navItemsA = navItemsR.find('a'),
                    subMenus = navItemsR.find('ul'),
                    $myAccountIcon = $('#aAccount');

                $(navItemsA)
                    .on('click', function (e) {

                        var subMenu = $(this).next();

                        if (subMenu.hasClass('submenu')) {

                            if (!subMenu.hasClass('goLink')) {
                                e.preventDefault();

                                if ($myAccountIcon.find('span.icon-label').hasClass('aAccount-label-on')) {
                                    $myAccountIcon.click();
                                }

                                subMenus.hide();
                                subMenus.removeClass('goLink');
                                subMenu.show();
                                subMenu.addClass('goLink');
                                return false;
                            }
                        }

                    });

                $('body').click(function (e) {
                    subMenus.hide();
                    subMenus.removeClass('goLink');
                });


                $myAccountIcon
                    .on('click', function (e) {
                        e.preventDefault();
                        subMenus.hide();
                        subMenus.removeClass('goLink');
                        return false;
                    });
            }

        },

        highlightNavItem: function () {
            var mainNav = document.getElementsByClassName("main-nav");
            for (var i = 0; i < mainNav.length; i++) {
                if ((location.pathname.indexOf(mainNav[i].pathname) > -1) &&
                    (mainNav[i].pathname !== "/") &&
                    (mainNav[i].host === location.host)) {
                    mainNav[i].classList.add("current-nav");
                }
            }
        },

        stickyNav: function () {
            var mainNavLinks = document.getElementById("headerBottom");
            //var sideNavLinks = document.getElementById("sidebarNav");
            var stickyMain = mainNavLinks.offsetTop;
            // var stickySideTop = 0;

            //if (sideNavLinks !== null) 
            //    stickySideTop = sideNavLinks.parentElement.offsetTop;            

            window.onscroll = function () {
                stickMainNav();
            };

            function stickMainNav() {
                if (window.pageYOffset >= stickyMain) {
                    mainNavLinks.classList.add("sticky");
                } else {
                    mainNavLinks.classList.remove("sticky");
                }
            }
        }
    };

    swg.leftNavigation = {
        init: function () {
            this.setActive();
        },

        setActive: function () {
            var sidebarMenu = $('.sidebar-menu'),
                dropdownMenu = $('.sidebar-menu .has-dropdown');

            if (sidebarMenu.length) {
                $(dropdownMenu).has('.is-active').addClass('is-open');
            }
        },
    };

    swg.sliders = {

        init: function () {
            this.$homeSlider = $('.home-slider');

            if (this.$homeSlider.length) {
                this.homeSlider();
            }

            this.featuredProdSlider();
            this.productSlider();
        },

        homeSlider: function () {
            var _this = this;

            this.$homeSlider.slick({
                fade: true,
                autoplay: true,
                pauseOnHover: true,
                infinite: true,
                speed: 500,
                autoplaySpeed: 5000,
                dots: false,
                zIndex: 1,
                arrows: false,
                lazyLoad: 'progressive',
                responsive: [{
                    breakpoint: 1024,
                    settings: {
                        dots: false
                    }
                }, {
                    breakpoint: 641,
                    settings: {
                        dots: true
                    }
                }],
                customPaging: function (slider, i) {
                    return '<button type="button gtm-slide-homepage-pagination-' + (i + 1) + '">' + (i + 1) + '</button>';
                }

            });

            $('.pagination ul li:first-child').addClass('active');

            this.$homeSlider.on('beforeChange', function (e, slick, current, next) {
                $('.pagination-slider').find('[data-goto=' + next + ']')
                    .parent('li')
                    .addClass('active')
                    .siblings()
                    .removeClass('active');
            });

            $('.pagination-slider li:first').addClass('active');

            $('.pagination-slider').find('a').on('click', function () {
                var $this = $(this),
                    slide = $this.data('goto');


                $('.pagination-slider').find('li').removeClass('active');
                $this.parent('li').addClass('active');
                _this.$homeSlider.slick('slickGoTo', slide);

            });

        },

        featuredProdSlider: function () {

            if (windowMobile) {
                $('.module-featured-products').slick({
                    dots: true,
                    arrows: false,
                    fade: true,
                    autoplay: true,
                    pauseOnHover: true,
                    infinite: true,
                    lazyLoad: 'progressive',
                    speed: 500,
                    autoplaySpeed: 5000
                });
            }
        },

        productSlider: function () {

            var url = window.location.toString();

            $('.subpage-slider').slick({
                dots: true,
                arrows: false,
                fade: true,
                autoplay: true,
                pauseOnHover: true,
                infinite: true,
                speed: 500,
                autoplaySpeed: 5000,
                lazyLoad: 'progressive',
                zIndex: 1,
                customPaging: function (slider, i) {
                    return '<button type="button" class="gtm-slide-pagination-' + (i + 1) + '">' + (i + 1) + '</button>';
                }
            });

            $('.slick-dots button').on('click', function (e) {
                e.preventDefault();
            });

        }
    };

    swg.resizeImg = {

        init: function () {
            this.baseModule();
            this.linkedModule();
            this.itemsModuleBig();
            this.itemsModuleSmall();
            this.equalHeights();
        },

        resize: function (content) {
            var $container = $(content).eq(1);

            $(content).find('img').each(function () {
                var $this = $(this);

                $this.removeClass('landscape').removeClass('portrait');
                $this.addClass($this.height() < $this.width() ? 'portrait' : 'landscape');


            });
        },

        baseModule: function () {
            swg.resizeImg.resize($('.base-module figure'));
        },

        linkedModule: function () {
            swg.resizeImg.resize($('.linked-module figure'));
        },

        itemsModuleBig: function () {
            swg.resizeImg.resize($('.large-4.items-module figure'));
        },

        itemsModuleSmall: function () {
            swg.resizeImg.resize($('.large-3.items-module figure'));
        },

        equalHeights: function () {
            var currentTallest = 0,
                currentRowStart = 0,
                rowDivs = [],
                $el,
                topPosition = 0;

            if (!windowMobile) {

                $('.data-equalizer-watch').each(function () {

                    $el = $(this);
                    topPosition = $el.position().top;
                    var currentDiv = 0;
                    if (currentRowStart != topPosition) {

                        // we just came to a new row.  Set all the heights on the completed row
                        for (currentDiv = 0; currentDiv < rowDivs.length; currentDiv++) {
                            rowDivs[currentDiv].height(currentTallest);
                        }

                        // set the variables for the new row
                        rowDivs.length = 0; // empty the array
                        currentRowStart = topPosition;
                        currentTallest = $el.height();
                        rowDivs.push($el);

                    } else {

                        // another div on the current row.  Add it to the list and check if it's taller
                        rowDivs.push($el);
                        currentTallest = (currentTallest < $el.height()) ? ($el.height()) : (currentTallest);

                    }

                    // do the last row
                    for (currentDiv = 0; currentDiv < rowDivs.length; currentDiv++) {
                        rowDivs[currentDiv].height(currentTallest);
                    }

                });
            }
        }
    };

    swg.placeholders = {
        init: function () {
            this.placeholder();
        },

        placeholder: function () {
            if (!Modernizr.input.placeholder) {
                var active = document.activeElement;

                $(':text').focus(function () {
                    if (typeof $(this).attr('placeholder') == 'undefined') return;

                    if ($(this).attr('placeholder') !== '' && $(this).val() == $(this).attr('placeholder')) {
                        $(this).val('').removeClass('hasPlaceholder');
                    }
                }).blur(function () {
                    if (typeof $(this).attr('placeholder') == 'undefined') return;

                    if ($(this).attr('placeholder') !== '' && ($(this).val() === '' || $(this).val() == $(this).attr('placeholder'))) {
                        $(this).val($(this).attr('placeholder')).addClass('hasPlaceholder');
                    }
                });
                $(':text').blur();
                $(active).focus();
                $('form:eq(0)').submit(function () {
                    $(':text.hasPlaceholder').val('');
                });
            }
        }
    };

    swg.print = {

        init: function () {
            this.popupPrintCss();
            this.printPages();
        },

        popupPrintCss: function () {

            $('a').on('click', function () {

                if ($(this).attr('data-reveal-id')) {
                    $('link[href="/assets/css/print.css"]').attr('href', '/assets/css/print_popups.css');
                }
            });

            $('.btn-popup-close').on('click', function () {
                $('link[href="/assets/css/print_popups.css"]').attr('href', '/assets/css/print.css');

            });
        },

        printPages: function () {

            $('.printPage').on('click', function (e) {
                e.preventDefault();
                window.print();
            });

            $('.printCart').on('click', function (e) {
                e.preventDefault();
                if (!$($(".itemTable.content")[0]).attr("data-linenumber"))
                    return;

                window.print();
            });

            $('#content_0_lbPrintOrder').on('click', function (e) {
                e.preventDefault();
                window.print();
            });

            $('#content_0_lbPrint').on('click', function (e) {
                e.preventDefault();
                window.print();
            });
        }
    };

    swg.emailpage = {
        init: function () {
            this.email();
        },

        email: function () {
            $('#emailPage').on('click', function (e) {
                var subject = $('#hfSbject').val(),
                    body = $('#hfText').val(),
                    url = window.location,
                    encodedUrl = encodeURIComponent(url);

                e.preventDefault();
                window.location = 'mailto:?subject= ' + subject + '&body= ' + body + ' ' + encodedUrl;
            });
        }
    };

    swg.popups = {

        init: function () {
            this.showSecondaryContent();
            this.closeForgot();
            this.showCustomList();
            this.closeWhenSubmit();
            this.bindBuySwagelokLink();
            this.validateRenameProductGroupList();
            this.validateChangeProductGroupList();
        },

        bindLoginPopUpClosedHandler: function () {
            $(document).on('closed.fndtn.reveal', '[data-reveal]', function () {
                var $modal = $(this);
                if ($modal.attr('id') === 'loginPopup') {
                    $('.secondary-content').hide();
                    $('.login-buttons').show();
                }
            });

        },

        loginFail: function () {
            if (swg.cookies.read('errorLogin') !== null) {
                swg.cookies.erase('errorLogin');
                $('#loginPopup').foundation('reveal', 'open');
            }
        },

        openForgot: function () {
            $('#loginPopup').foundation('reveal', 'open');
            $('.login-buttons').hide();
            $('.login-content').hide();
            $(".secondary-content[data-content='forgotUsername']").fadeIn();
        },

        showSecondaryContent: function () {

            $('.first-content a').on('click', function () {
                var dataVal = $(this).data('content');
                if ($(this).hasClass('forgotUsername')) {
                    var $userInput = $('#txtUsername'),
                        $passwordInput = $('#txtPassword');
                    $userInput.val("");
                    $passwordInput.val("");
                    $('.secondary-content').hide();
                    $('.secondary-content input').val("");
                    $('.login-buttons').hide();
                    $('.login-content').hide();
                    $('.login-content .column').removeClass('error errorEmail');
                    $(".secondary-content[data-content='" + dataVal + "']").fadeIn();
                }
            });
        },

        closeForgot: function () {
            $('.close-forgot').on('click', function () {
                $('.login-buttons').show();
                $('.login-content').show();
                $('.secondary-content').hide();
            });
        },

        showCustomList: function () {

            $('.favorite-prod-checkbox').on('change', function () {
                $('.new-custom-list-wrapper').hide().removeClass('open');
            });

            $('#new-custom-list').on('change', function () {

                if ($('.new-custom-list-wrapper').hasClass('open')) {
                    $('.new-custom-list-wrapper').hide().removeClass('open');
                } else {
                    $('.new-custom-list-wrapper').show().addClass('open');
                }
            });
        },

        closeWhenSubmit: function () {
            $('.forgotUsername .button').on('click', function (e) {
                var formBox = $(this).parents('.login-content'),
                    inputEmail = $(formBox).find('input[type="email"]'),
                    inputValue = $(inputEmail).val(),
                    emailRegex = new RegExp(/^([\w\.\-]+)@([\w\-]+)(([\.\-](\w){1,63})+)$/i),
                    valid = emailRegex.test(inputValue);

                $('.login-content .column').removeClass('error errorEmail');

                if (inputEmail.length) {
                    if (inputValue === '') {
                        e.preventDefault();
                        inputEmail.parent().addClass('error');
                        return false;
                    } else if (!valid) {
                        e.preventDefault();
                        inputEmail.parent().addClass('errorEmail');
                        return false;
                    } else {
                        var $userInput = $('#txtUsername'),
                            $passwordInput = $('#txtPassword');
                        $userInput.val("");
                        $passwordInput.val("");

                        //__doPostBack('ctl02$ctl00$lnkUsername', '');
                        return true;
                    }
                }
            });

        },

        validateLogin: function () {

            //refactoring here: is better to cache JQuery elements and add $ in front of them
            var $userInput = $('#txtUsername'),
                $passwordInput = $('#txtPassword');

            //Bind Blur events to Inputs
            $userInput.on('blur', function (e) {
                swg.validation.validateText($userInput, false);
            });
            $passwordInput.on('blur', function (e) {
                swg.validation.validateText($passwordInput, false);
            });

            $('#lnkLoginButton').on('click', function (e) {
                e.preventDefault();

                var isPasswordValid = swg.validation.validateText($passwordInput, false);
                var isInputValid = swg.validation.validateText($userInput, false);

                if (isInputValid && isPasswordValid) {
                    var url = '/servicesWS/Forms.asmx/Login',
                        userName = $(this).val(),
                        dataObject = { 'userName': $userInput.val(), 'password': $passwordInput.val(), 'url': window.location.href };

                    $.ajax({
                        url: url,
                        type: 'POST',
                        contentType: 'application/json',
                        dataType: 'json',
                        data: JSON.stringify(dataObject),
                        success: function (data) {
                            if (data.d.HasError) {
                                $("#loginError").html(data.d.ErrorMessage);
                                $passwordInput.val("");
                                $("#loginError").show();
                                return false;
                            } else {
                                $("#loginError").hide();
                                window.location.href = data.d.RedirectUrl;
                            }
                        }
                    });
                    return false;
                }
                else {
                    return false;
                }
            });

            $('#btnForgotPassword').on('click', function (e) {
                e.preventDefault();

                var $emailAddress = $("#txtEmailAddresUsername");

                var isEmailAddressValid = swg.validation.validateEmail($emailAddress, false);
                var isEmailAddressFilled = swg.validation.validateText($emailAddress, false);

                if (isEmailAddressValid && isEmailAddressFilled) {
                    var url = '/servicesWS/Forms.asmx/ForgotPassword',
                        dataObject = { 'email': $emailAddress.val() };

                    $.ajax({
                        url: url,
                        type: 'POST',
                        contentType: 'application/json',
                        dataType: 'json',
                        data: JSON.stringify(dataObject),
                        success: function (data) {
                            $(".forgotSuccess").show();
                            $(".close-forgot").trigger("click");
                        }
                    });
                    return false;
                }
                else {
                    return false;
                }
            });
        },

        loginButtonsFocus: function () {
            $('#txtUsername, #txtPassword').keypress(function (e) {
                if (e.which === 13) {
                    $('#lnkLoginButton').click();
                    return false;
                }
            });

            //Forgot Username
            $('#txtEmailAddresUsername').keypress(function (e) {
                if (e.which === 13) {
                    $('.forgotUsername .button').click();
                    return false;
                }
            });

            //Forgot password
            $('#txtPasswordUsername').keypress(function (e) {
                if (e.which === 13) {
                    $('.forgotPassword .button').click();
                    return false;
                }
            });
        },

        bindBuySwagelokLink: function () {
            $('.aBuySwagelok').on('click', function (e) {
                e.preventDefault();
                $('#corporatePopup').foundation('reveal', 'open');

            });
        },

        validateAddFavoriteList: function () {
            var $form = $("#add_list"),
                $listName = $form.find('#txtAddFavoriteListName');

            $listName.on('blur', function (e) {
                swg.validation.validateText($listName, false);
            });

            $form.find("#btnAddListSave").on('click', function (e) {
                e.preventDefault();
                var isValidForm = true;

                isValidForm = swg.validation.validateText($listName, false) && isValidForm;
                isValidForm = swg.validation.validateHTML($listName, false) && isValidForm;

                if (isValidForm) {

                    var url = '/servicesWS/Forms.asmx/AddProductGroupList';
                    var name = $("#txtAddFavoriteListName").val();
                    var dataObject = { 'name': name };

                    $.ajax({
                        url: url,
                        type: 'POST',
                        contentType: 'application/json',
                        dataType: 'json',
                        data: JSON.stringify(dataObject),
                        success: function (data) {
                            window.location.reload();
                        }
                    });

                    return false;
                }
                else {

                    return false;
                }
            });
        },

        validateRenameProductGroupList: function () {
            var $form = $("#renameFavoritesPopup");
            var $listName = $form.find('#txtRenameFavoriteListName');

            $listName.on('blur', function (e) {
                swg.validation.validateText($listName, false);
            });

            $form.find("#btnRenameListSave").on('click', function (e) {
                e.preventDefault();
                var isValidForm = true;

                isValidForm = swg.validation.validateText($listName, false) && isValidForm;
                isValidForm = swg.validation.validateHTML($listName, false) && isValidForm;

                if (isValidForm) {

                    var url = '/servicesWS/Forms.asmx/RenameProductGroupList';
                    var dataObject = { 'name': $listName.val(), "id": $form.find("#txtFavoriteListId").val() };

                    $.ajax({
                        url: url,
                        type: 'POST',
                        contentType: 'application/json',
                        dataType: 'json',
                        data: JSON.stringify(dataObject),
                        success: function (data) {
                            window.location.reload();
                        }
                    });

                    return false;
                }
                else {

                    return false;
                }
            });
        },

        validateChangeProductGroupList: function () {
            var $form = $("#changeListPopup");
            var $listName = $form.find('#ddlChangeList');

            $listName.on('blur', function (e) {
                swg.validation.validateText($listName, false);
            });

            $form.find("#btnChangeListSave").on('click', function (e) {
                e.preventDefault();
                var isValidForm = true;

                isValidForm = swg.validation.validateText($listName, false) && isValidForm;
                isValidForm = swg.validation.validateHTML($listName, false) && isValidForm;

                if (isValidForm) {

                    var url = '/servicesWS/Forms.asmx/ChangeProductGroupList';

                    var listId = $form.find("#currentListId").val();
                    var name = $form.find("#currentListName").html();
                    var groupId = $form.find("#ddlChangeList").val();
                    var dataObject = { 'listId': listId, 'name': name, 'groupId': groupId };

                    $.ajax({
                        url: url,
                        type: 'POST',
                        contentType: 'application/json',
                        dataType: 'json',
                        data: JSON.stringify(dataObject),
                        success: function (data) {
                            window.location.reload();
                        }
                    });

                    return false;
                }
                else {

                    return false;
                }
            });
        }
    };

    swg.products = {

        init: function () {
            this.$perPage = $('#itemsPage, #itemsPage2');
            this.itemsPerPage = 24;
            this.events();
            this.dropdownMenu();
            this.pageNumber = 0;

            if ($('#product-types').length) {
                this.loadProductTypes(0);
            }
            this.resizeProductImage();
            productPage = 0;

        },

        events: function () {
            var _this = this,
                select = $(".itemPerPageClass");

            _this.$perPage.on('change', function () {
                _this.itemsPerPage = $(this).val();
                _this.loadProductTypes(0, function (data) {
                    _this.totalItems = data.resultCount;
                    _this.createPagination();
                });

                $(".products-list .product-item").remove();

                select.not(this).val(this.value);

                if (windowMobile) {
                    $("html, body").animate({
                        scrollTop: 700
                    }, "slow");
                    return false;
                }

            });

        },

        createPagination: function (data) {
            var totalItems = data.d.resultCount,
                totalPages = totalItems / this.itemsPerPage,
                roundTotalPages = Math.ceil(totalPages + 1),
                paginationTemplate = $("#pagination-template").html(),
                paginationCompile = Handlebars.compile(paginationTemplate);


            data = {
                items: []
            };


            if (totalPages >= 2) {
                for (var i = 0; i < roundTotalPages; i++) {
                    data.items.push({
                        number: i
                    });
                }

                //render html handlebars
                var compiledHtmlPagination = paginationCompile(data);
                $(".pagination-placeholder").html(compiledHtmlPagination);

                if (windowMobile) {
                    $(".pagination").on('click', function () {
                        $("html, body").animate({
                            scrollTop: 700
                        }, "slow");
                        return false;
                    });
                }
            }
        },

        showListPagination: function (first, last) {
            var _this = this,
                listPagesArr = $(".list-pages"),
                lastPageNumber = $(".list-pages:last").text(),
                firstPageNumber = $(".list-pages:first").text();


            listPagesArr.css('cursor', 'pointer');

            listPagesArr.hide();
            listPagesArr.slice(first, last).show();

            listPagesArr.on('click', function (e) {
                $(this).addClass('current');

                $(".products-list .product-item").remove();

                _this.pageNumber = $(".list-pages.current span").text();
                var currPagination = _this.pageNumber;

                _this.loadProductTypes(currPagination);
            });

            $(".first-page-pagination").html(firstPageNumber).attr('data-page', firstPageNumber);
            $(".last-page-pagination").html(lastPageNumber).attr('data-page', lastPageNumber);

            $(".first-page-pagination").on('click', function () {
                $(this).addClass('current');

                $(".products-list .product-item").remove();

                _this.pageNumber = firstPageNumber;
                var currPagination = _this.pageNumber;

                _this.loadProductTypes(currPagination);
            });

            $(".last-page-pagination").on('click', function () {
                $(this).addClass('current');

                $(".products-list .product-item").remove();

                _this.pageNumber = lastPageNumber;
                var currPagination = _this.pageNumber;

                _this.loadProductTypes(currPagination);
            });

        },

        handleArrows: function (direction) {

            var _this = this,
                prevArrow = $('.top-pagination-class .arrow a:first'),
                prevArrowBottom = $('.bottom-pagination .arrow a:first'),
                nextArrow = $('.top-pagination-class .arrow a:last'),
                nextArrowBottom = $('.bottom-pagination .arrow a:last'),
                nextPrevPageValue = parseInt(this.pageNumber);
            _this.showListPagination(1, 6);

            if (nextPrevPageValue <= 0) {
                nextPrevPageValue = 1;
            }

            nextArrow.on('click', function () {
                var nextPage = nextPrevPageValue + 1;
                $(".products-list .product-item").remove();
                _this.loadProductTypes(nextPage);

            });

            nextArrowBottom.on('click', function () {
                var nextPage = nextPrevPageValue += 1;
                $(".products-list .product-item").remove();
                _this.loadProductTypes(nextPage);

            });


            prevArrow.on('click', function () {
                var prevPage = nextPrevPageValue -= 1;
                $(".products-list .product-item").remove();
                _this.loadProductTypes(prevPage);
            });

            prevArrowBottom.on('click', function () {
                var prevPage = nextPrevPageValue -= 1;
                $(".products-list .product-item").remove();
                _this.loadProductTypes(prevPage);
            });

        },


        dropdownMenu: function () {

            var $trigger = $('.current');

            if (windowTablet || windowDesktop) {

                $trigger.on('click', function (e) {
                    e.preventDefault();
                    $('.dropdown ul').stop().slideUp();
                    $('.dropdown').css('background-image', 'url(/assets/images/icons/arrow-down.png)');
                    $(this).next('ul').stop(true, false).slideToggle(300, function () {
                        if ($(this).is(':visible')) {
                            $(this).parent('.dropdown').css('background-image', 'url(/assets/images/icons/arrow-up.png)');
                        } else {
                            $(this).parent('.dropdown').css('background-image', 'url(/assets/images/icons/arrow-down.png)');
                        }
                    });
                });
            }
        },

        selectCurrent: function () {

            $('.dropdown ul a').on('click', function (e) {
                var selectedTxt = $(this).text(),
                    $current = $(this).parent().parent('ul').prev('.current');

                e.preventDefault();
                $current.text(selectedTxt);
                $(this).parent().parent('ul').slideUp();
            });
        },

        handlerData: function (data) {

            var templateSource = $('#product-types').html(),
                template = Handlebars.compile(templateSource),
                productHTML = template(data.d.data),
                resultCount = data.d.resultCount,
                userSing = data.d.signedIn;


            if (productHTML === '') {
                console.log('error: no data');
            }
            $(productHTML).hide().appendTo('.products-list').fadeIn(800);

            if (userSing === false) {
                $('.properties #singIn').hide();
            } else {
                $('.properties a[data-reveal-id="loginPopup"]').hide();
            }

        },


        loadProductTypes: function (goTo) {

            var _this = this,
                groupType = $('#SPAGroup').val(),
                type = $('#SPAType').val(),
                itemId = $('#itemId').val(),
                categoriesFilter = $('#product-categories input[type=checkbox]:checked').map(function () {
                    return $(this).data('category');
                }),
                pageSize = parseInt($('#itemsPage option:selected').val(), 10),

                url = '/servicesws/products.asmx/Filter',
                dataObject = {
                    "group": groupType, // required
                    "type": type, // optional (should be sent â€œâ€)
                    "itemId": itemId,
                    "cat": "", // optional (should be sent â€œâ€) if you have value, you must pass type and group
                    "pageSize": this.itemsPerPage, // required
                    "pageNumber": goTo - 1 // required

                };

            $.ajax({
                url: url,
                type: 'POST',
                contentType: 'application/json',
                dataType: 'json',
                data: JSON.stringify(dataObject),
                beforeSend: function () {
                    $(".loading").show();
                }
            })
                .then(function (data) {
                    _this.handlerData(data);
                    _this.createPagination(data);
                    _this.handleArrows(data);


                })
                .always(function () {
                    $(".loading").hide();

                    var currActivePage = parseInt(goTo);

                    var counter = currActivePage - 2,
                        counter2 = currActivePage + 3,
                        bottomPagination = $(".bottom-pagination .list-pages"),
                        finalBottomPages = $(".bottom-pagination .list-pages span").length - 3,
                        finalPages = $(".list-pages span").length - 3;

                    if (currActivePage >= finalPages) {
                        $(".pagination a[data-direction='Next']").hide();
                        $(".last-page-pagination").hide();
                        counter = finalPages - 2;
                        counter2 = finalPages + 5;
                    }

                    if (currActivePage >= finalBottomPages) {
                        $(".pagination a[data-direction='Next']").hide();
                        $(".last-page-pagination").hide();
                        counter = finalBottomPages - 2;
                        counter2 = finalBottomPages + 5;
                    }

                    $(".pagination span[data-page='0'], .pagination a[data-direction='Prev']").hide();

                    if (counter <= 0) {
                        counter = 1;
                        counter2 = 6;
                    }

                    $(".list-pages span").each(function (index) {
                        if (index == goTo) {
                            $(".list-pages span[data-page='" + goTo + "']").addClass('current');
                        }
                    });

                    if (goTo <= 3) {
                        $(".pagination a[data-direction='Prev']").hide();

                    } else if (goTo >= 4) {
                        $(".pagination a[data-direction='Prev']").show();
                        $(".first-page-pagination").show();
                        $(".first-page-pagination").text("1");

                    }

                    if (goTo <= 0) {
                        $(".list-pages span[data-page='1']").addClass('current');
                    }
                    $(".list-pages").hide();
                    $(".list-pages").slice(counter, counter2).show();

                    bottomPagination.hide();
                    bottomPagination.slice(counter, counter2).show();


                    swg.products.resizeProductImage();



                })
                .fail(function (e) {
                    console.log('error');
                });

            this.pageNumber = goTo;

        },

        resizeProductImage: function () {
            var productList = $('.product-thumbnail'),
                productContent = $('.product-thumbnail figure'),
                productImageBox = $('.product-image figure'),
                productListContent = $('.product-item-inner figure'),
                imageWidth01 = productContent.eq(1).width(),
                imageWidth02 = productImageBox.eq(1).width(),
                imageWidth03 = productListContent.eq(1).width();

            productContent.find('img').height(imageWidth01);

            if (productImageBox.length) {
                productImageBox.find('img').height(imageWidth02);
            }

            if (productList.length) {
                productListContent.find('img').height(imageWidth03);

            }
        }
    };

    swg.calculator = {

        init: function () {
            this.selectCalculationType();
            this.selectSystemMedium();
            this.selectSpecificGravity();
            this.sendCalculate();
            this.bindBlurEventValidation();
        },

        selectCalculationType: function () {

            $('#Gas').change(
                function () {
                    $('#systemMediumLiquid').addClass('hide');
                    $('#systemMediumGas').removeClass('hide');

                    $('#FlowRateUnitLiquid').addClass('hide');
                    $('#FlowRateUnitGas').removeClass('hide');

                    $('#CVFlowUnitLiquid').addClass('hide');
                    $('#CVFlowUnitGas').removeClass('hide');

                    var optionGravity = $('#systemMediumGas').find("option:selected").val();
                    $('#gravity').val(optionGravity);
                    $('#gravity').parent().removeClass('error');
                    $('#gravity').next().hide();
                }
            );

            $('#Liquid').change(
                function () {
                    $('#systemMediumGas').addClass('hide');
                    $('#systemMediumLiquid').removeClass('hide');

                    $('#FlowRateUnitGas').addClass('hide');
                    $('#FlowRateUnitLiquid').removeClass('hide');

                    $('#CVFlowUnitGas').addClass('hide');
                    $('#CVFlowUnitLiquid').removeClass('hide');

                    var optionGravity = $('#systemMediumLiquid').find("option:selected").val();
                    $('#gravity').val(optionGravity);
                    $('#gravity').parent().removeClass('error');
                    $('#gravity').next().hide();
                }
            );

        },

        selectSystemMedium: function () {
            $('input.js-calc-type-flow').change(
                function () {
                    $('.js-calc-type-flow-container').addClass('hide');
                    $('.js-calc-type-cv-container').removeClass('hide');
                }
            );

            $('input.js-calc-type-cv').change(
                function () {
                    $('.js-calc-type-cv-container').addClass('hide');
                    $('.js-calc-type-flow-container').removeClass('hide');
                }
            );
        },

        selectSpecificGravity: function () {
            $('select[name="systemMedium"]').change(
                function () {
                    var option = $(this).find("option:selected").val();
                    $('#gravity').val(option);
                    $('#gravity').parent().removeClass('error');
                    $('#gravity').next().hide();
                }
            );
        },

        sendCalculate: function () {
            $('#calculateButton, #reCalculateButton').on('click', function (e) {
                e.preventDefault();
                var $form = $('.form-cv-calculator');

                $form.find('input').each(function () {
                    var $element = $(this);
                    $element.parent().removeClass('error');
                    $element.parent().removeClass('cvBEerror');
                });

                $form.find('.cvBEerror').hide();

                if (swg.calculator.validateCVFields()) {

                    if (!$('#messageContent .cv-value').hasClass('hide')) {
                        $('#messageContent .cv-value').addClass('hide');
                        $('#messageContent .cv-value .result').empty();
                    }

                    if (!$('#messageContent .flow-value').hasClass('hide')) {
                        $('#messageContent .flow-value').addClass('hide');
                        $('#messageContent .flow-value .result').empty();
                    }

                    swg.calculator.serviceCalculator();
                }
            });
        },

        validateCVFields: function () {
            var $form = $('.form-cv-calculator');
            var validFields = true,
                isCV = $('input[name^=modalCalculator]:checked').val() === '1';
            //the above tells us which Radio button is selected

            $($form.find('.required').get().reverse()).each(function () {
                var $element = $(this);
                if (isCV && $element[0].id != 'cvNumber') {
                    validFields = swg.validation.validateText($element, true) && validFields;
                } else if (!isCV && $element[0].id != 'FlowRate') {
                    validFields = swg.validation.validateText($element, true) && validFields;
                }

            });

            return validFields;
        },

        bindBlurEventValidation: function () {
            var $form = $('.form-cv-calculator');

            $form.find(".required").each(function () {
                var $element = $(this);
                $element.on('blur', function (e) {
                    swg.validation.validateText($element, false);
                });
            });

        },

        serviceCalculator: function () {
            var flowUnit;
            if ($('input[name="modalCalculator$CalculationReq"]:checked').val() == "1") {
                if ($('#FlowRateUnitGas').hasClass('hide')) {
                    flowUnit = $('#FlowRateUnitLiquid').val();
                } else if ($('#FlowRateUnitLiquid').hasClass('hide')) {
                    flowUnit = $('#FlowRateUnitGas').val();
                }
            } else {
                if ($('#CVFlowUnitGas').hasClass('hide')) {
                    flowUnit = $('#CVFlowUnitLiquid').val();
                } else if ($('#CVFlowUnitLiquid').hasClass('hide')) {
                    flowUnit = $('#CVFlowUnitGas').val();
                }
            }


            var url = '/servicesws/CVCalculator.asmx/Calculator',

                calculationReq = $('input[name="modalCalculator$CalculationReq"]:checked').val(),
                calculationType = $('input[name="mediumType"]:checked').val(),
                pressureOne = $('#inletPressure').val(),
                pressureOneUnit = $("#inletPressureUnit").val(),
                pressureTwo = $('#outletPressure').val(),
                pressureTwoUnit = $("#outletPressureUnit").val(),
                temperature = $('#Temperature').val(),
                temperatureUnit = $("#temperatureUnit").val(),
                specificGravity = $('#gravity').val(),
                flow = $('#FlowRate').val(),
                cvValue = $('#cvNumber').val(),

                dataObject = {
                    "calculatorData": {
                        "calculationType": calculationType,
                        "calculationReq": calculationReq,
                        "pressureOne": pressureOne,
                        "pressureOneUnit": pressureOneUnit,
                        "pressureTwo": pressureTwo,
                        "pressureTwoUnit": pressureTwoUnit,
                        "temperature": temperature,
                        "temperatureUnit": temperatureUnit,
                        "specificGravity": specificGravity,
                        "flow": flow,
                        "cvValue": cvValue,
                        "flowUnit": flowUnit
                    }
                };



            $.ajax({
                url: url,
                type: 'POST',
                contentType: 'application/json',
                dataType: 'json',
                data: JSON.stringify(dataObject),
                beforeSend: function () {
                }
            })
                .then(function (data) {
                    var message = data.d.message,
                        result = data.d.data.calculationResultText;

                    if (message !== undefined) {

                        if (message == 100) {
                            $('.p1 input').parent().addClass('cvBEerror');
                            $('.p2 input').parent().addClass('cvBEerror');
                        }
                        $('.error-code-' + message).show();
                    }

                    if (result !== undefined) {

                        if (calculationReq === '1') {
                            $('#messageContent .cv-value').removeClass('hide');
                            $('#messageContent .cv-value .result').append(result);
                        }
                        if (calculationReq === '2') {
                            $('#messageContent .flow-value').removeClass('hide');
                            $('#messageContent .flow-value .result').append(result);
                        }
                        $("#calculateButton").hide();
                        $("#reCalculateButton").show();
                    }

                })
                .always(function () {
                })
                .fail(function (e) {
                    console.log('error');
                });
        }
    };

    swg.autocomplete = {
        init: function () {
            this.startAutocomplete();
            this.searchByEnter();
        },
        autoCompleteCustomRender: function (ul, item) {
            var $li = $('<li>'),
                $img = $('<img>');

            $img.attr({
                src: '/assets/images/search-items/' + item.icon
            });
            $li.append($img);
            $li.append($('<p>').text($(item).attr("label")));

            return $li.appendTo(ul);
        },
        startAutocomplete: function () {
            /* search-promo file only in core languages - if on minisite that does 
                not have a core language, default to EN version */
            var langArray = ["CN", "DE", "EN", "ES", "FR", "JP", "RU"];
            var langCookie = swg.cookies.read('LanguageCd', true);
            var splitLang = langCookie ? langCookie.split('=') : ['', ''];
            var lang = splitLang[1];

            if (langArray.indexOf(lang) == -1)
                var autoCompleteFile = "/assets/js/xml/search-promo-EN.xml";
            else
                var autoCompleteFile = "/assets/js/xml/search-promo-" + lang + ".xml";

            $.ajax({
                url: autoCompleteFile,
                dataType: "xml",
                context: this,
                success: function (xmlResponse) {
                    var data = $("SearchItem", xmlResponse).map(function () {
                        return {
                            value: $(this).attr('value'),
                            url: $(this).attr('url'),
                            icon: $(this).attr('icon')
                        };
                    }).get();

                    $("#iGlobalSearch, #iGlobalSearchMobile").keypress(function (e) {
                        if (e.which === 13) {
                            e.preventDefault();
                            swg.autocomplete.search();
                        }
                    });

                    $("#iGlobalSearch").autocomplete({
                        maxResults: 15,
                        source: function (request, response) {
                            var results = $.ui.autocomplete.filter(data, request.term);
                            response(results.slice(0, this.options.maxResults));
                        },
                        minLength: 4,
                        //                       select: function (event, ui) {
                        /* only going to go to the product detail page in corporate. We are not going to the 
                            product detail page from a minisite, because it bypasses the 'going back to corp' popup
                            which causes issues especially for the non-core language minisites */
                        /*                          if ($("#hdnIsMinisite").val() !== "Y") {
                                                       if (ui.item.url === "PD") {
                                                           var productDetailUrl = $("#hdnProductDetailUrl").val() + "?part=" + ui.item.value;
                                                           if (fnOldSearchOnClick === null) {
                                                               fnOldSearchOnClick = $("#lnkSearch").attr("href");
                                                           }
                                                           $("#lnkSearch").attr("href", productDetailUrl);
                                                           if (($("#hdnProductDetailUrl").val().indexOf('https://') >= 0)) {
                                                               if (minisites.globalFns) {
                                                                   minisites.globalFns.isCorporateLink($("#lnkSearch"));
                                                               }
                                                           }
                                                       } 
                                                   }
                                                   $("#iGlobalSearch").val(ui.item.value);
                                                   $('#lnkSearch').click();
                                               }*/
                    }).autocomplete("instance")._renderItem = this.autoCompleteCustomRender;

                    $("#iGlobalSearch").on("change", function (e) {
                        if (fnOldSearchOnClick !== null) {
                            $("#lnkSearch").attr("href", fnOldSearchOnClick);
                        }
                    });

                    $('#lnkSearch').on('click', function (e) {
                        e.preventDefault();
                        swg.autocomplete.search();
                    });

                    $("#iGlobalSearchMobile").autocomplete({
                        maxResults: 15,
                        source: function (request, response) {
                            var results = $.ui.autocomplete.filter(data, request.term);
                            response(results.slice(0, this.options.maxResults));
                        },
                        minLength: 4,
                    }).autocomplete("instance")._renderItem = this.autoCompleteCustomRender;

                    $("<span class='arrow-autocomplete'></span>").insertBefore(".ui-autocomplete");
                }
            });
        },

        search: function () {
            var href = $("#lnkSearch").attr("href");
            var url = new URL(href);
            var dataHref = $("#lnkSearch").attr("data-href");
            var searchTerm = '';
            var noLangPopup = $("#NoLangPopup").val() === "true";
            if ($("#iGlobalSearch").val() !== "") {
                searchTerm = $("#iGlobalSearch").val();
            } else {
                searchTerm = $("#iGlobalSearchMobile").val();
            }
            if (searchTerm != '')
                if (href.indexOf(dataHref) != -1) {
                    $("#lnkSearch").attr("href", (href));
                    url.searchParams.append("text", searchTerm);
                    if ($("#hdnIsMinisite").val() === "Y" && !noLangPopup) {
                        //add logic to display popup
                        $('#corporatePopup').foundation('reveal', 'open');
                        $('#aContinueToCorp').prop("href", url);
                    } else {
                        window.location.href = (url);
                    }
                }
                else {
                    window.location.href = href;
                }
        },

        searchByEnter: function () {
            $('#iGlobalSearch').focus(function () {
                $(document).bind('keypress', function (e) {
                    if (e.which === 13) {
                        $('#lnkSearch').click();
                    }
                });
            });
            $('#iGlobalSearchMobile').focus(function () {
                $(document).bind('keypress', function (e) {
                    if (e.which === 13) {
                        $('#lnkSearch').click();
                    }
                });
            });
        }
    };


    swg.cookies = {
        create: function (name, value, days, domain) {
            var expires;
            if (days) {
                if (days === -1) {
                    expires = "; expires=Thu, 01 Jan 1970 00:00:01 GMT;";
                }
                else {
                    var date = new Date();
                    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
                    expires = "; expires=" + date.toUTCString();
                }
            } else {
                expires = "";
            }
            var domainInfo = "domain=" + domain;
            document.cookie = name + "=" + value + expires + "; path=/;" + domainInfo;
        },

        read: function (name, isEnvironmentCookie) {//SM: Added isEnvironmentCookie for those cookies with the environment prefix. Example: LOCAL_DCODE
            var nameEQ = name + "=";
            var ca = document.cookie.split(';');
            for (var i = 0; i < ca.length; i++) {
                var c = ca[i];
                while (c.charAt(0) == ' ') c = c.substring(1, c.length);
                if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
                if (isEnvironmentCookie) { //SM: if isEnvironmentCookie it will check if the name contains.
                    if (c.indexOf(nameEQ) > 0) return c.substring(nameEQ.length, c.length);
                }
            }
            return null;
        },

        erase: function (name) {
            this.create(name, "", -1);
        },

        getDomain: function () {
            return ".swagelok.com";

        },
    };

    swg.leaderbio = {
        init: function () {
            this.pdfLink();
        },

        pdfLink: function () {
            if (windowMobile) {
                if ($("#js-download-bio").length) {
                    var pdfBio = $('#js-download-bio');
                    $('.content h1').after(pdfBio);
                }
            }
        },
    };

    swg.approveOrder = {
        init: function () {
            this.validation();
        },

        validation: function () {

        }
    };

    swg.flowregulator = {
        init: function () {
            this.bindCalculateClick();
            this.bindClearClick();
            this.bindcboSeriesChange();
            this.bindNbrToCompareChange();
            this.bindrblSeriesType();
            this.bindcboTemperatureUnitsChange();
            this.bindcboPressureUnitsChange();
            this.bindcboGasTypeChange();
            this.bindcboLineVelocityUnits();
            this.validateInputs();
            //this.validateDecimal();
            //this.validateDropdown();
            // this.validateRegulatorItem();
        },//end init
        bindcboLineVelocityUnits: function () {
            ////LineVelocityUnits_SelectedIndexChanged
            $('#cboLineVelocityUnits').on('change', function (e) {
                e.preventDefault();
                var units = $(this).children('option:selected').val().split("||");
                $('.inputvelocityunit').text('(' + units[2] + ')');
                $('.inputlengthunit').text('(' + units[1] + ')');
            });

        }, //bindcboLineVelocityUnits
        bindClearClick: function () {
            $('#btnClear').on('click', function (e) {
                e.preventDefault();
                location.reload();
            });
        },//end bindClearClick
        bindcboPressureUnitsChange: function () {
            //PressureUnits_SelectedIndexChanged
            $('#cboPressureUnits').on('change', function (e) {
                e.preventDefault();
                var postdata = {
                    scController: "FlowRegulator",
                    scAction: "cboPressureUnitsChange",
                    specs: swg.flowregulator.getRequestSpecification(),
                };

                $.ajax({
                    type: "POST",
                    url: window.location.href,
                    cache: false,
                    context: this,
                    data: postdata,
                })
                    .done(function (data) {
                        if (data.HtmlString) {
                            $('#lblStandardPressure').text(data.HtmlString);
                        }
                        if (data.Properties) {
                            $(".pcodelabel").text(data.Properties["plabel"]);
                        }
                    })
                    .fail(function (data) { console.log(data.Errors); });

            });

        },//end bindcboPressureUnitsChange
        bindcboTemperatureUnitsChange: function () {
            //TemperatureUnits_SelectedIndexChanged
            $('#cboTemperatureUnits').on('change', function (e) {
                e.preventDefault();

                var postdata = {
                    scController: "FlowRegulator",
                    scAction: "cboTemperatureUnitsChange",
                    specs: swg.flowregulator.getRequestSpecification(),
                };

                $.ajax({
                    type: "POST",
                    url: window.location.href,
                    cache: false,
                    context: this,
                    data: postdata,
                })
                    .done(function (data) {
                        if (data.HtmlString) {
                            $('#lblTempStandardGasVolume').text(data.HtmlString);
                        }
                        if (data.Properties) {
                            $(".tcodelabel").text(data.Properties["tlabel"]);
                        }
                    })
                    .fail(function (data) { console.log(data.Errors); });
            });
        },//end bindcboTemperatureUnitsChange
        bindrblSeriesType: function () {
            //SeriesType_SelectedIndexChanged
            $('input[name=rblSeriesType]').on('change', function (e) {
                e.preventDefault();

                var postdata = {
                    scController: "FlowRegulator",
                    scAction: "rblSeriesTypeChange",
                    rblSeriesType: $('input[name=rblSeriesType]:checked').val(),
                };

                $.ajax({
                    type: "POST",
                    url: window.location.href,
                    cache: false,
                    context: this,
                    data: postdata,
                })
                    .done(function (data) {
                        if (data.HtmlString) {
                            $('.cboSeries').each(function (index, item) {
                                item.innerHTML = data.HtmlString;
                            });

                            if (postdata.rblSeriesType == 1) {
                                //IsPressureRegulatorSeries = true
                                $('.txtOutletTubingPipeID').removeAttr("disabled").addClass("required");
                                $('.txtMaxLineVelocity').removeAttr("disabled").addClass("required");
                                $(".InletPressureLabel").show();
                                $(".BackPressureLabel").hide();
                            }
                            else {
                                $('.txtOutletTubingPipeID').attr("disabled", "disabled").removeClass("required");
                                $('.txtMaxLineVelocity').attr("disabled", "disabled").removeClass("required");
                                $(".InletPressureLabel").hide();
                                $(".BackPressureLabel").show();
                            }

                            var inletReqVal = $.trim($("#rfvInletPressure").html());
                            var inletReqOther = $.trim($("#rfvInletPressure").attr("data-othertext"));
                            $("#rfvInletPressure").html(inletReqOther);
                            $("#rfvInletPressure").attr("data-othertext", inletReqVal);

                            var inletDecVal = $.trim($("#cvInletPressure").html());
                            var inletDecOther = $.trim($("#cvInletPressure").attr("data-othertext"));
                            $("#cvInletPressure").html(inletDecOther);
                            $("#cvInletPressure").attr("data-othertext", inletDecVal);

                        }
                    })
                    .fail(function (data) { console.log(data.Errors); });
            });
        }, //end bindrblSeriesType
        bindNbrToCompareChange: function () {
            $('#cboNbrToCompare').on('change', function (e) {
                e.preventDefault();
                var newValue = $(this).children('option:selected').val();
                var oldValue = $(this).attr('data-currentnbr');
                if (newValue > oldValue) {
                    //ADD NEW PARITALS
                    var postdata = {
                        scController: "FlowRegulator",
                        scAction: "NbrToCompareChange",
                        newNbr: newValue,
                        oldNbr: oldValue,
                        ds: $('.flow-regulator').attr('data-ds')
                    };
                    $.ajax({
                        type: "POST",
                        url: window.location.href,
                        cache: false,
                        context: this,
                        data: postdata,
                    })
                        .done(function (data) {
                            if (data.HtmlString) {
                                $('.regulatoritem:last').after(data.HtmlString);
                                $(this).attr('data-currentnbr', newValue);
                            }
                            else {
                                console.log("no html string for nbr compare");
                            }
                        })
                        .fail(function (data) { console.log(data.Errors); });
                }
                else {
                    //REMOVE EXISTING
                    var diff = oldValue - newValue;
                    for (var i = 1; i <= diff; i++) {
                        $('.regulatoritem:last').remove();
                    }
                    $(this).attr('data-currentnbr', newValue);
                }
            });
        }, //end bindNbrToCompareChange
        bindcboSeriesChange: function () {
            //Series_SelectedIndexChanged
            $(document).on('change', '#cboSeries', function (e) {
                e.preventDefault();
                var regItem = $(this).parent().parent();
                swg.flowregulator.resetRegulatorItemValidation("#" + regItem.attr("id"));

                var newSeries = $(this).children('option:selected');
                var postdata = {
                    scController: "FlowRegulator",
                    scAction: "cboSeriesChange",
                    newSeries: newSeries.attr('data-key')
                };

                $.ajax({
                    type: "POST",
                    url: window.location.href,
                    cache: false,
                    context: this,
                    data: postdata,
                })
                    .done(function (data) {
                        if (data.HtmlString) {
                            var pressurerange = regItem.find('#cboPressureControlRange');
                            pressurerange.html("");
                            pressurerange.append(data.HtmlString);
                            pressurerange.focus();
                        }

                        if (newSeries.text().indexOf("RA") == 0) {
                            regItem.find(".RatioLabel").show();
                            regItem.find(".PressureControlRangeLabel").hide();
                        }
                        else {
                            regItem.find(".RatioLabel").hide();
                            regItem.find(".PressureControlRangeLabel").show();
                        }

                        if (newSeries.val()) {
                            var units = $('#cboLineVelocityUnits option:selected')[0].value.split("||");
                            var values = newSeries.val().split("||");
                            if (units[0] == "1") {
                                regItem.find('#txtOutletTubingPipeID').val(values[1]);
                                regItem.find('#txtOutletTubingPipeID').trigger("blur");
                            }
                            else {
                                regItem.find('#txtOutletTubingPipeID').val(values[2]);
                                regItem.find('#txtOutletTubingPipeID').trigger("blur");
                            }
                        }

                    })
                    .fail(function (data) { console.log(data.Errors); });

            });
        },//end bindcboSeriesChange
        bindcboGasTypeChange: function () {
            //former JS method SetGasTypeFields(this, cboSeriesKey)
            $(document).on('change', '.cboGasType', function (e) {
                e.preventDefault();
                var namespace = "#" + $(this).attr("var_heading");

                swg.flowregulator.resetRegulatorItemValidation(namespace);

                var newGasType = $(this).children('option:selected');
                var newGasTypeSplit = newGasType.val().split("||");

                var objCbo = $(this);
                var objMass = $("#txtMolarMass", namespace);
                var objMassRfv = $("#rfvMolarMass", namespace);
                var objMassCv = $("#cvMolarMass", namespace);
                var objRatio = $("#txtSpecificHeatRatio", namespace);
                var objRatioRfv = $("#rfvMolarMass", namespace);
                var objRatioCv = $("#cvMolarMass", namespace);
                var objLineVel = $("#txtMaxLineVelocity", namespace);
                var objInputSplit = $("#cboLineVelocityUnits option:selected").val().split("||");

                if (newGasType.val() === "") {
                    objMass.attr("disabled", "disabled");
                    objMass.removeClass("required");
                    objMass.value = '';
                    objRatio.attr("disabled", "disabled");
                    objRatio.removeClass("required");
                    objRatio.value = '';

                }
                else {
                    if (newGasTypeSplit[1] == 'False') {
                        objMass.attr("disabled", "disabled");
                        objMass.val(newGasTypeSplit[4]);
                        objMass.removeClass("required");
                        objRatio.attr("disabled", "disabled");
                        objRatio.val(newGasTypeSplit[5]);
                        objRatio.removeClass("required");
                    }
                    else {
                        objMass.removeAttr("disabled");
                        objMass.val('');
                        objMass.addClass("required");
                        objRatio.removeAttr("disabled");
                        objRatio.val('');
                        objRatio.addClass("required");
                    }

                    if ($('input[name=rblSeriesType]:checked').val() == 1) {
                        if (objInputSplit[0] == '1') {
                            objLineVel.val(newGasTypeSplit[2]);
                        }
                        else {
                            objLineVel.val(newGasTypeSplit[3]);
                        }
                    }
                    else {
                        objLineVel.val('');
                    }
                }

            });

        }, //end bindcboGasTypeChange
        bindCalculateClick: function () {
            $('#btnCalculate').on('click', function (e) {
                e.preventDefault();

                var regulatorItems = [];
                var passValidation = true;

                $('.regulatoritem').each(function () {
                    var regId = $(this).attr('id');
                    if (swg.flowregulator.validateRegulatorItem("#" + regId)) {
                        regulatorItems.push(swg.flowregulator.getRegulatorItem(regId));
                    }
                    else {
                        passValidation = false;
                    }
                });

                if (passValidation) {
                    var postdata = {
                        scController: "FlowRegulator",
                        scAction: "CalculateClick",
                        userinput: regulatorItems,
                        specs: swg.flowregulator.getRequestSpecification(),
                        ds: $('.flow-regulator').attr('data-ds')
                    };

                    $.ajax({
                        type: "POST",
                        url: window.location.href,
                        cache: false,
                        context: this,
                        data: postdata,
                    })
                        .done(function (data) {
                            if (data.AlertMessage) {
                                alert(data.AlertMessage);
                            }
                            if (data.OpenUrl) {
                                window.open(data.OpenUrl);
                            }
                        })
                        .fail(function (data) { console.log(data.Errors); });
                }
            });
        }, //end bindCalculateClick
        cleanMultiLingualUnits: function (value) {

            if (value && value != '' && value.includes(',')) {
                value = value.replace(/,/g, '.');
            }
            return value;
        },
        getRequestSpecification: function () {
            var tempFlowUnit = $('#cboMassFlowUnits option:selected');
            var tempLineVelocityUnit = $('#cboLineVelocityUnits option:selected').val().split("||");
            var tempPressureUnit = $('#cboPressureUnits option:selected');
            //some languages use ',' in place of '.' for decimal points.  None of these fields will legitimately have a ','.  Replace before parsing.
            var tempPressureUnitSplit = this.cleanMultiLingualUnits(tempPressureUnit.val()).split("||")
            var tempTempatureUnit = this.cleanMultiLingualUnits($('#cboTemperatureUnits option:selected').val()).split("||");

            var specModel = {
                rblSeriesType: $('input[name=rblSeriesType]:checked').val(),
                comparenumber: $('#cboNbrToCompare option:selected').val(),//int
                flowunitkey: tempFlowUnit.val(), //int
                flowunitcode: tempFlowUnit.text(),//string
                inputunitskey: tempLineVelocityUnit ? tempLineVelocityUnit[0] : 1,//int [0]
                inputlengthunitsname: tempLineVelocityUnit ? tempLineVelocityUnit[1] : "0",//string [1]
                inputvelocityunitname: tempLineVelocityUnit ? tempLineVelocityUnit[2] : "",//string [2]
                pressurekey: tempPressureUnit.attr('data-key'),//int
                pressurecode: tempPressureUnit.text(),//string
                pressurefactor: tempPressureUnitSplit[1], //decimal
                pressureoffset: tempPressureUnitSplit[2], //decimal
                tempkey: tempTempatureUnit ? tempTempatureUnit[0] : 1,//int [0]
                tempcode: tempTempatureUnit ? tempTempatureUnit[1] : "0",//string [1],
                tempfactor: tempTempatureUnit ? tempTempatureUnit[2] : "0.0",//decimal
                tempoffset: tempTempatureUnit ? tempTempatureUnit[3] : "0.0",//decimal
                uniqueidentifier: $('#txtUniqueIdentifier').val()
            };

            return specModel;
        }, //end  getRequestSpecification
        getRegulatorItem: function (regNamespace) {
            var regItem = $('#' + regNamespace);
            if (regItem) {
                var cboSeries = regItem.find('#cboSeries option:selected');
                var cboPressureControlRange = regItem.find('#cboPressureControlRange option:selected');
                var cboGasType = regItem.find('#cboGasType option:selected');
                return {
                    rblSeriesType: $('input[name=rblSeriesType]:checked').val(),
                    cboSeriesKey: cboSeries.attr('data-key'),
                    cboSeriesValue: cboSeries.val(),
                    cboSeriesText: cboSeries.text(),
                    cboPressureControlRangeValue: cboPressureControlRange.val(),
                    cboPressureControlRangeText: cboPressureControlRange.text(),
                    cboPressureControlRangeKey: cboPressureControlRange.attr('data-key'),
                    cboGasTypeValue: cboGasType.val(),
                    cboGasTypeText: cboGasType.text(),
                    cboGasTypeKey: cboGasType.attr('data-key'),
                    cboGasTypeUserDefined: cboGasType.val().split("||")[1],
                    txtInletPressure: regItem.find('#txtInletPressure').val(),
                    txtSetPressure: regItem.find('#txtSetPressure').val(),
                    txtInletTemperature: regItem.find('#txtInletTemperature').val(),
                    txtSpringRate: regItem.find('#txtSpringRate').val(),
                    txtOutletTubingPipeID: regItem.find('#txtOutletTubingPipeID').val(),
                    txtMaxLineVelocity: regItem.find('#txtMaxLineVelocity').val(),
                    txtMolarMass: regItem.find('#txtMolarMass').val(),
                    txtSpecificHeatRatio: regItem.find('#txtSpecificHeatRatio').val(),
                    RegulatorNumber: regItem.attr("data-key")
                };
            }
        },//end getRegulatorItem,
        validateDropdown: function (inputElement) {
            if (!inputElement.hasClass('required'))
                return true;

            if (inputElement.children("option:selected").length <= 0 || inputElement.children("option:selected").val() == "") {
                inputElement.parent().addClass('error');
                inputElement.next('.error-required').show();
                return false;
            }

            return true;
        },
        validateDecimal: function (inputElement) {
            var str = inputElement.val();
            if (!inputElement.hasClass('required'))
                return true;
            var parent = inputElement.parent().parent();

            if (str === "") {

                parent.addClass('error');
                parent.find('.error-required').show();
                return false;
            }
            else {
                parent.removeClass('error');
                parent.find('.error-required').hide();
            }

            if (str !== "" && isNaN(str)) {

                parent.addClass('error');
                parent.find('.error-decimal').show();
                return false;
            }
            else {
                parent.removeClass('error');
                parent.find('.error-decimal').hide();
            }

            return true;
        },
        validateRegulatorItem: function (regNamespace) {
            var passValidation = true;
            passValidation = swg.flowregulator.validateDropdown($('.cboSeries', regNamespace)) && passValidation;
            passValidation = swg.flowregulator.validateDropdown($('.cboPressureControlRange', regNamespace)) && passValidation;
            passValidation = swg.flowregulator.validateDecimal($('.txtOutletTubingPipeID', regNamespace)) && passValidation;
            passValidation = swg.flowregulator.validateDropdown($('.cboGasType', regNamespace)) && passValidation;
            passValidation = swg.flowregulator.validateDecimal($('.txtMaxLineVelocity', regNamespace)) && passValidation;
            passValidation = swg.flowregulator.validateDecimal($('.txtInletPressure', regNamespace)) && passValidation;
            passValidation = swg.flowregulator.validateDecimal($('.txtSetPressure', regNamespace)) && passValidation;
            passValidation = swg.flowregulator.validateDecimal($('.txtInletTemperature', regNamespace)) && passValidation;
            passValidation = swg.flowregulator.validateDecimal($('.txtMolarMass', regNamespace)) && passValidation;
            passValidation = swg.flowregulator.validateDecimal($('.txtSpecificHeatRatio', regNamespace)) && passValidation;
            //passValidation = swg.flowregulator.validateDecimal($('.txtSpringRate', regNamespace)) && passValidation;

            return passValidation;
        },
        validateInputs: function () {

            $('.cboSeries').on("blur", function (e) {
                swg.flowregulator.validateDropdown($(this));
            });
            $('.cboPressureControlRange').on("blur", function (e) {
                swg.flowregulator.validateDropdown($(this));
            });
            $('.txtOutletTubingPipeID').on("blur", function (e) {
                swg.flowregulator.validateDecimal($(this));
            });
            $('.cboGasType').on("blur", function (e) {
                swg.flowregulator.validateDropdown($(this));
            });
            $('.txtMaxLineVelocity').on("blur", function (e) {
                swg.flowregulator.validateDecimal($(this));
            });
            $('.txtInletPressure').on("blur", function (e) {
                swg.flowregulator.validateDecimal($(this));
            });
            $('.txtSetPressure').on("blur", function (e) {
                swg.flowregulator.validateDecimal($(this));
            });
            $('.txtInletTemperature').on("blur", function (e) {
                swg.flowregulator.validateDecimal($(this));
            });
            $('.txtMolarMass').on("blur", function (e) {
                swg.flowregulator.validateDecimal($(this));
            });
            $('.txtSpecificHeatRatio').on("blur", function (e) {
                swg.flowregulator.validateDecimal($(this));
            });
        },
        resetDecimalValidation: function (inputElement) {
            inputElement.parent().parent().removeClass('error');
            inputElement.parent().next('.error-required').hide();
            inputElement.parent().next('.error-decimal').hide();
        },
        resetDropdownValidation: function (inputElement) {
            inputElement.parent().removeClass('error');
            inputElement.next('.error-required').hide();
        },
        resetRegulatorItemValidation: function (regNamespace) {
            swg.flowregulator.resetDropdownValidation($('.cboSeries', regNamespace));
            swg.flowregulator.resetDropdownValidation($('.cboPressureControlRange', regNamespace));
            swg.flowregulator.resetDecimalValidation($('.txtOutletTubingPipeID', regNamespace));
            swg.flowregulator.resetDropdownValidation($('.cboGasType', regNamespace));
            swg.flowregulator.resetDecimalValidation($('.txtMaxLineVelocity', regNamespace));
            swg.flowregulator.resetDecimalValidation($('.txtInletPressure', regNamespace));
            swg.flowregulator.resetDecimalValidation($('.txtSetPressure', regNamespace));
            swg.flowregulator.resetDecimalValidation($('.txtInletTemperature', regNamespace));
            swg.flowregulator.resetDecimalValidation($('.txtMolarMass', regNamespace));
            swg.flowregulator.resetDecimalValidation($('.txtSpecificHeatRatio', regNamespace));
            swg.flowregulator.resetDecimalValidation($('.txtSpringRate', regNamespace));

        }
    };

    swg.biopharmcert = {
        init: function () {
            this.bindbtnSearchDocsClick();
            this.bindbtnSearchHeatClick();
        },
        bindbtnSearchDocsClick: function () {
            $('#btnSearchDocs', '.form-biopharm').on('click', function (e) {
                var namespace = '.form-biopharm';
                $('.ajaxProgress', '.form-biopharm').show();
                $.ajax({
                    type: "POST",
                    url: "/featureapi/v1/biopharm/biosearchdoc",
                    cache: false,
                    context: this,
                    data: {
                        term: $('#txtSearchDocs', namespace).val(),
                        ds: $(namespace).attr('data-ds')
                    },
                })
                    .done(function (data) {
                        console.log("Action completed, success = " + data.success);

                        if (!data.success && data.noresult) {
                            $('#lblLotSearchResults', namespace).hide();
                            $('#lblLotSearchHeader', namespace).hide()
                            $('#lblLotSearchNoResults', namespace).show().text(data.noresult + data.noresulttwo)
                        }
                        else if (data.success) {
                            $('#lblLotSearchNoResults', namespace).hide()
                            $('#lblLotSearchHeader', namespace).show().text(data.header);
                            $('#lblLotSearchResults', namespace).show()
                            var linkObj = $('#lotsearchresultlink', namespace);
                            linkObj.attr('href', data.resultLink);
                            linkObj.attr('target', data.resultName);
                            linkObj.text(data.resultName);
                        }
                    })
                    .fail(function (response) {
                        console.log("Submit Action fail");
                    })
                    .complete(function () { $('.ajaxProgress', '.form-biopharm').hide(); })
                    ;
            });
        },//end bindbtnSearchDocsClick
        bindbtnSearchHeatClick: function () {
            $('#btnSearchHeat', '.form-biopharm').on('click', function (e) {
                var searchNbr = $('#txtSearchHeatNbr', '.form-biopharm').val();
                if (searchNbr) {
                    window.open('/Tools Pages/heat_certification.aspx?Heat_Num=' + searchNbr, '_blank');
                }
            });
        },
    };

    swg.videos = {
        init: function () {
            this.checkAllowFullScreen();
        },

        checkAllowFullScreen: function () {
            var i, frames;
            frames = document.getElementsByTagName("iframe");
            for (i = 0; i < frames.length; i++) {
                if (!frames[i].hasAttribute("allowfullscreen")) {
                    frames[i].setAttribute("allowfullscreen", "allowfullscreen");
                }
            }
        }
    };

    swg.language = {

        changeLanguage: function (langCookieName, lang, time) {
            var domain;
            var destination = lang;

            if (lang.indexOf("/") == 0) {
                lang = lang.split("/")[1];
            } else {
                lang = lang.split("/")[3];
            }

            if (window.location.hostname.indexOf(".com.cn") > -1) {
                domain = ".swagelok.com.cn";
            } else {
                domain = ".swagelok.com";
            }

            if (domain === ".swagelok.com.cn" && lang !== "zh" && lang !== "en") {
                this.goToDotCom(langCookieName, destination, lang, time);
            } else if (domain === ".swagelok.com" && lang === "zh") {
                this.goToDotComCN(langCookieName, destination, lang, time);
            } else {
                swg.cookies.create(langCookieName, this.translateLang(lang), time, domain);
            }
        },

        goToDotCom: function (langCookieName, destination, lang, time) {
            swg.cookies.create(langCookieName, this.translateLang(lang), time, ".swagelok.com");
            location.href = destination;
        },

        goToDotComCN: function (langCookieName, destination, lang, time) {
            swg.cookies.create(langCookieName, this.translateLang(lang), time, ".swagelok.com.cn");
            location.href = destination;
        },

        translateLang: function (lang) {
            if (lang === "zh") {
                return "CN";
            } else if (lang === "ja") {
                return "JP";
            } else {
                return lang;
            }
        }
    },

        swg.validation = (function () {
            function validateHTML($inputElement, focus) {
                var regex = new RegExp(/(<([^>]+)>)/ig),
                    result = regex.test($inputElement.val());

                if (result) {
                    $inputElement.parent().addClass('errorHTML');
                    if (focus) {
                        $inputElement.focus();
                    }
                    return false;
                } else {
                    $inputElement.parent().removeClass('errorHTML');
                    return true;
                }

            }

            function validateNumber($inputElement, focus) {
                var str = $inputElement.val();
                if (isNaN(str)) {
                    $inputElement.parent().addClass('error');
                    if (focus) {
                        $inputElement.focus();
                    }
                    return false;
                } else if (parseInt(str) <= 0) {
                    $inputElement.parent().addClass('error');
                    if (focus) {
                        $inputElement.focus();
                    }
                    return false;
                } else if (str === "") {
                    $inputElement.parent().addClass('error');
                    if (focus) {
                        $inputElement.focus();
                    }
                    return false;
                }
                return true;
            }

            function validateText($inputElement, focus) {
                if ($inputElement.val() === '') {
                    $inputElement.parent().addClass('error');
                    if (focus) {
                        $inputElement.focus();
                        $('html, body').animate({
                            scrollTop: $inputElement.offset().top
                        }, 0);
                    }
                    return false;
                }
                //else --> is valid and do the following
                $inputElement.parent().removeClass('error');
                return true;
            }

            function validateTextTest($inputElement, focus) {
                if ($inputElement.val() === '') {
                    $inputElement.parent().addClass('missing-data');
                    if (focus) {
                        $inputElement.focus();
                        $('html, body').animate({
                            scrollTop: $inputElement.offset().top
                        }, 0);
                    }
                    return false;
                }
                //else --> is valid and do the following
                $inputElement.parent().removeClass('missing-data');
                return true;
            }

            function validateTextCustomErrorLocation($inputElement, focus) {

                var id = $inputElement.prop("id");

                if ($inputElement.val() === '') {
                    $inputElement.parent().addClass('error');

                    $("." + id).addClass('error');

                    if (focus) {
                        $inputElement.focus();
                        $('html, body').animate({
                            scrollTop: $inputElement.offset().top
                        }, 0);
                    }
                    return false;
                }
                //else --> is valid and do the following
                $inputElement.parent().removeClass('error');
                $("." + id).removeClass('error');
                return true;
            }

            function validateRegexCustomErrorLocation($input, regExpression, focus) {

                var id = $input.prop("id");
                var inputValue = $input.val();

                if (inputValue) {
                    var customRegex = new RegExp(regExpression), isValid = customRegex.test(inputValue);

                    if (isValid) {
                        $("." + id).addClass('hide');
                        return true;
                    }

                    //else --> is Not Valid
                    $("." + id).removeClass('hide');

                    if (focus) {
                        $input.focus();
                    }
                    return false;
                } else {
                    return false;
                }
            }

            function validateRegexCustomErrorLocationCustomValue($input, regExpression, focus, errorMessage) {

                var id = $input.prop("id");
                var inputValue = $input.val();

                if (inputValue) {
                    var customRegex = new RegExp(regExpression), isValid = customRegex.test(inputValue);

                    if (isValid) {
                        $("." + id).addClass('hide');
                        return true;
                    }

                    //else --> is Not Valid
                    $("." + id).removeClass('hide');
                    $("." + id).find("span").html(errorMessage);

                    if (focus) {
                        $input.focus();
                    }
                    return false;
                } else {
                    return false;
                }
            }

            function validateRegexCustomErrorLocationCustomValueWithValue($input, regExpression, focus, errorMessage, inputValue) {

                var id = $input.prop("id");

                if (inputValue) {
                    var customRegex = new RegExp(regExpression), isValid = customRegex.test(inputValue);

                    if (isValid) {
                        $("." + id).addClass('hide');
                        return true;
                    }

                    //else --> is Not Valid
                    $("." + id).removeClass('hide');
                    $("." + id).find("span").html(errorMessage);

                    if (focus) {
                        $input.focus();
                    }
                    return false;
                } else {
                    return false;
                }
            }

            function validateDistributor($inputElement, focus) {
                if (!swg.cookies.read('DCODE', true)) {
                    $inputElement.parent().addClass('error');
                    if (focus) {
                        $inputElement.focus();
                        $('html, body').animate({
                            scrollTop: $inputElement.offset().top
                        }, 0);
                    }
                    return false;
                }
                //else --> is valid and do the following
                $inputElement.parent().removeClass('error');
                return true;
            }

            function validateEmail($inputEmail, focus) {
                var inputValue = $inputEmail.val();
                if (inputValue) {
                    var emailRegex = new RegExp(/^([\w\.\-]+)@([\w\-]+)(([\.\-](\w){1,63})+)$/i),
                        isValid = emailRegex.test(inputValue);
                    if (isValid) {
                        $inputEmail.parent().removeClass('errorEmail');
                        return true;
                    }
                    //else --> is Not Valid
                    $inputEmail.parent().addClass('errorEmail');
                    if (focus) {
                        $inputEmail.focus();
                        $('html, body').animate({
                            scrollTop: $inputEmail.offset().top
                        }, 0);
                    }
                    return false;
                } else {
                    return false;
                }
            }

            function validateInputTextLength($inputField, length, focus) {
                var inputField = $inputField.val();
                if (inputField.length > length) {
                    $inputField.parent().addClass('errorlength');
                    if (focus) {
                        $inputField.focus();
                        $('html, body').animate({
                            scrollTop: $inputField.offset().top
                        }, 0);
                    }
                    return false;
                }
                $inputField.parent().removeClass('errorlength');
                return true;
            }

            function validateCheckbox($checkbox, focus) {
                if (!$checkbox.prop('checked')) {
                    $checkbox.parent().addClass('error');
                    if (focus) {
                        $checkbox.focus();
                        $('html, body').animate({
                            scrollTop: $checkbox.offset().top
                        }, 0);
                    }
                    return false;
                }
                //else --> is valid and do the following
                $checkbox.parent().removeClass('error');
                return true;
            }

            function validatePassword($pass1, $pass2, focus) {
                var allValid = true,
                    passRegex = new RegExp(/^.{8,64}$/),
                    validPassword = passRegex.test($pass1.val());
                if ($pass1.val() !== $pass2.val()) {
                    $pass1.parent().addClass('errorPassword');
                    $pass2.parent().addClass('errorPassword');
                    if (focus) {
                        $pass1.focus();
                        $('html, body').animate({
                            scrollTop: $pass1.offset().top
                        }, 0);
                    }
                    allValid = false;
                } else {
                    $pass1.parent().removeClass('errorPassword');
                    $pass2.parent().removeClass('errorPassword');
                }
                if (!validPassword) {
                    $pass1.parent().addClass('errorInvalidPassword');
                    $pass2.parent().addClass('errorInvalidPassword');
                    if (focus) {
                        $pass1.focus();
                        $('html, body').animate({
                            scrollTop: $pass1.offset().top
                        }, 0);
                    }
                    allValid = false;
                } else {
                    $pass1.parent().removeClass('errorInvalidPassword');
                    $pass2.parent().removeClass('errorInvalidPassword');
                }
                if (allValid) {
                    return true;
                }
                return false;
            }

            function validateLettersOnly($input, focus) {
                var inputValue = $input.val();
                if (inputValue) {
                    var emailRegex = new RegExp(/^[^0-9]+$/i),
                        isValid = emailRegex.test(inputValue);
                    if (isValid) {
                        $input.parent().removeClass('error');
                        return true;
                    }
                    //else --> is Not Valid
                    $input.parent().addClass('error');
                    if (focus) {
                        $input.focus();
                        $('html, body').animate({
                            scrollTop: $input.offset().top
                        }, 0);
                    }
                    return false;
                } else {
                    return false;
                }
            }

            function validateRegex($input, regExpression, focus) {
                var inputValue = $input.val();
                if (inputValue) {
                    var customRegex = new RegExp(regExpression),
                        isValid = customRegex.test(inputValue);
                    if (isValid) {
                        $input.parent().removeClass('error');
                        return true;
                    }
                    //else --> is Not Valid
                    $input.parent().addClass('error');
                    if (focus) {
                        $input.focus();
                    }
                    return false;
                } else {
                    return false;
                }
            }

            function getUtcDateByFormat($inputField, dtFmt) {
                var inputField = $inputField.val();
                var dtParts;
                switch (dtFmt) {
                    // Check for 4 digits in year
                    case 'mm/dd/yyyy':
                        dtParts = inputField.split('/');
                        if (dtParts.length === 3 && dtParts[2].length === 4) {
                            inputField = dtParts[2] + '-' + dtParts[0] + '-' + dtParts[1];
                        } else {
                            inputField = '';
                        }
                        break;
                    case 'dd/mm/yyyy':
                        dtParts = inputField.split('/');
                        if (dtParts.length === 3 && dtParts[2].length === 4) {
                            inputField = dtParts[2] + '-' + dtParts[1] + '-' + dtParts[0];
                        } else {
                            inputField = '';
                        }
                        break;
                    case 'dd.mm.yyyy':
                        dtParts = inputField.split('.');
                        if (dtParts.length === 3 && dtParts[2].length === 4) {
                            inputField = dtParts[2] + '-' + dtParts[1] + '-' + dtParts[0];
                        } else {
                            inputField = '';
                        }
                        break;
                    case 'yyyy/mm/dd':
                        dtParts = inputField.split('/');
                        if (dtParts.length === 3 && dtParts[0].length === 4) {
                            inputField = dtParts[0] + '-' + dtParts[1] + '-' + dtParts[2];
                        } else {
                            inputField = '';
                        }
                        break;
                    case 'dd-mm-yyyy':
                        dtParts = inputField.split('-');
                        if (dtParts.length === 3 && dtParts[2].length === 4) {
                            inputField = dtParts[2] + '-' + dtParts[1] + '-' + dtParts[0];
                        } else {
                            inputField = '';
                        }
                        break;
                }

                if (inputField != '')
                    inputField += 'T00:00:00';

                return inputField;
            }

            function validateDeliveryDate($inputField, dtFmt, focus) {
                var isFieldEmpty = $inputField.val().length === 0;

                if (isFieldEmpty) {
                    $inputField.parent().removeClass('error');
                    return true;
                }

                var inputField = getUtcDateByFormat($inputField, dtFmt);
                var today = new Date();

                var inputDt = new Date(inputField);
                var isValidDt = inputDt instanceof Date && !isNaN(inputDt);

                if (!isValidDt || today >= inputDt) {
                    $inputField.parent().addClass('error');
                    if (focus) {
                        $inputField.focus();
                        $('html, body').animate({
                            scrollTop: $inputField.offset().top
                        }, 0);
                    }
                    return false;
                } else {
                    $inputField.parent().removeClass('error');
                    return true;
                }
            }

            function validateDate($inputField, dtFmt, focus, errorTagClass) {
                var isFieldEmpty = $inputField.val().length === 0;

                if (isFieldEmpty && errorTagClass === '') {
                    $inputField.parent().removeClass('error');
                    return true;
                } else if (isFieldEmpty && errorTagClass !== '') {
                    $('.' + errorTagClass).hide();
                    return true;
                }

                var inputField = getUtcDateByFormat($inputField, dtFmt);
                var inputDt = new Date(inputField);
                var isValidDt = inputDt instanceof Date && !isNaN(inputDt);

                if (!isValidDt) {
                    if (errorTagClass === '') {
                        $inputField.parent().addClass('error');
                    } else {
                        $('.' + errorTagClass).show();
                    }

                    if (focus) {
                        $inputField.focus();
                        $('html, body').animate({
                            scrollTop: $inputField.offset().top
                        }, 0);
                    }
                    return false;
                } else {
                    if (!errorTagClass) {
                        $inputField.parent().removeClass('error');
                    } else {
                        $('.' + errorTagClass).hide();
                    }
                    return true;
                }
            }

            function validateDateRange($inputFieldDateFrom, $inputFieldDateTo, dtFmt, focus) {
                if ($inputFieldDateFrom.val().length === 0 || $inputFieldDateTo.val().length === 0) {
                    $('.date-range-error').hide();
                    return true;
                }

                var dtFromFmt = getUtcDateByFormat($inputFieldDateFrom, dtFmt);
                var dtToFmt = getUtcDateByFormat($inputFieldDateTo, dtFmt);
                var dateFrom = new Date(dtFromFmt);
                var dateTo = new Date(dtToFmt);
                var isValidDtRange = dateTo instanceof Date && !isNaN(dateTo) && dateFrom instanceof Date && !isNaN(dateFrom);

                if (isValidDtRange && dateTo >= dateFrom)
                    isValidDtRange = true;
                else {
                    isValidDtRange = false;
                }

                if (!isValidDtRange) {
                    $('.date-range-error').show();
                    if (focus) {
                        $inputFieldDateTo.focus();
                        $('html, body').animate({
                            scrollTop: $inputFieldDateTo.offset().top
                        }, 0);
                    }
                    return false;
                } else {
                    $('.date-range-error').hide();
                    return true;
                }
            }

            //Exposing as Public
            return {
                validateText: validateText,
                validateEmail: validateEmail,
                validateInputTextLength: validateInputTextLength,
                validateCheckbox: validateCheckbox,
                validatePassword: validatePassword,
                validateDistributor: validateDistributor,
                validateNumber: validateNumber,
                validateLettersOnly: validateLettersOnly,
                validateRegex: validateRegex,
                validateHTML: validateHTML,
                validateTextCustomErrorLocation: validateTextCustomErrorLocation,
                validateTextTest: validateTextTest,
                validateRegexCustomErrorLocation: validateRegexCustomErrorLocation,
                validateRegexCustomErrorLocationCustomValue: validateRegexCustomErrorLocationCustomValue,
                validateRegexCustomErrorLocationCustomValueWithValue: validateRegexCustomErrorLocationCustomValueWithValue,
                validateDeliveryDate: validateDeliveryDate,
                validateDate: validateDate,
                validateDateRange: validateDateRange
            };

        })();

    //------ Initialize Functions-------
    swg.navigation.init();
    swg.leftNavigation.init();
    swg.sliders.init();
    swg.resizeImg.init();
    swg.placeholders.init();
    swg.print.init();
    swg.emailpage.init();
    swg.products.init();
    swg.calculator.init();
    swg.autocomplete.init();
    swg.leaderbio.init();
    swg.productDetail.init();
    swg.flowregulator.init();
    swg.biopharmcert.init();
    swg.videos.init();

}(jQuery, window));

